window.ckEditBox = function (){
	if($('.textbox').length){
		let token = document.head.querySelector('meta[name="csrf-token"]');
		var config = {
			customConfig: '/vendor/unisharp/laravel-ckeditor/customConfig.js',
		};

		if($('.textbox').attr('data-toolbar') !== undefined){
			config['toolbar'] = $('.textbox').attr('data-toolbar');
		}
		
		if($('.textbox').attr('data-uploadurl') !== undefined){
			config['filebrowserUploadUrl'] 		= $('.textbox').attr('data-uploadurl') + "upload?_token=" + token.content;
			config['filebrowserUploadMethod'] 	= 'form';
		}
		
		if($('.textbox').attr('height') !== undefined){
			config['height'] 		= $('.textbox').attr('height');
		}
		
		$('.textbox').ckeditor(config);
	}
}